<script>
  export let codeText;

  let modal;

  const openModal = () => {
    modal.style.display = "block";
  };
  // When the user clicks on <span> (x), close the modal
  const spanonclick = () => {
    modal.style.display = "none";
  };

  // When the user clicks anywhere outside of the modal, close it
  const onModalClick = (event) => {
    if (event.target == modal) {
      modal.style.display = "none";
    }
  };
</script>

<button class="edit-button" on:click={openModal}>Preview</button>
<div
  id="myModal"
  bind:this={modal}
  on:click={onModalClick}
  style="{codeText};background: rgba(0,0,0, 0.8);"
  class="modal"
>
  <!-- Modal content -->

  <div class="modal-content">
    <span class="close" on:click={spanonclick}>&times;</span>
    <div class="gradient-container">
      <div class="bg-gradient" style={codeText} />
      <p class="text-of-gradient-style">{codeText}</p>
      <button
        class="edit-button"
        on:click={() => {
          const cb = navigator.clipboard;
          cb.writeText(codeText).then(() => alert("Style copied"));
        }}>Copy Style</button
      >
    </div>
  </div>
</div>

<style>
  /* The Modal (background) */
  .modal {
    display: none; /* Hidden by default */
    position: fixed; /* Stay in place */
    z-index: 1; /* Sit on top */
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    /* overflow: auto; Enable scroll if needed */
  }

  /* Modal Content/Box */
  .modal-content {
    background-color: #fefefe;
    margin: 10% auto; /* 15% from the top and centered */
    padding: 5px 10px;
    border: 1px solid #888;
    width: 80%; /* Could be more or less, depending on screen size */
    height: 65%;
    opacity: 1 !important ;
  }
  .gradient-container {
    display: flex;
    flex-direction: column;
    width: 90%;
    height: 78%;
    border: 1px solid gray;
    margin: 12px auto;
  }
  .text-of-gradient-style {
    font-size: 12px;
    border-top: 3px ridge rgb(165, 161, 161);
    padding: 6;
    margin: 0;
  }
  .bg-gradient {
    width: 100%;
    height: 100%;
    /* margin: 12px 6px; */
  }

  /* .edit-button {
    border: 1px outset grey;
    border-radius: 20px;
    background-color: azure;
    margin: 6px auto;
    box-shadow: 2px 2px 4x rgba(24, 24, 24, 0.8);
  } */

  /* The Close Button */
  .close {
    color: #aaa;
    float: right;
    font-size: 28px;
    font-weight: bold;
  }

  .close:hover,
  .close:focus {
    color: black;
    text-decoration: none;
    cursor: pointer;
  }
</style>
